<template>
  <bsp-dialog :title="$t('cost.cost102')" :dialogVisible.sync="visible" top="15vh" @closeButton="closeDialog" width="1100px"><!-- 选择票据 -->
    <template #body v-loading="loading">
      <div class="flexTable">
        <div class="gridHead">
          <el-form ref="searchForm" :model="searchForm" style="padding: 0; margin-top: 0; width: 100%;">
<!--            <el-row>-->
<!--              <el-col :span="10">-->
<!--                <el-form-item label="票据开具日期" label-width="30%">-->
<!--                  <el-date-picker v-model="searchForm.startDate" type="date" value-format='yyyy-MM-dd' placeholder="开始日期" style="width:40%;margin-left: 5px;" ></el-date-picker>-->
<!--                  至-->
<!--                  <el-date-picker v-model="searchForm.endDate" type="date" value-format='yyyy-MM-dd' placeholder="结束日期" style="width:40%;margin-right: 5px;" ></el-date-picker>-->

<!--                </el-form-item>-->
<!--              </el-col>-->
<!--              <el-col :span="4">-->
<!--                <el-button type="primary"  style="float: left;margin: 0 5px;" @click="handleReset">重置</el-button>-->
<!--                <el-button type="primary"  style="float: left;margin: 0 5px;" @click="handleSearch">查询</el-button>-->
<!--              </el-col>-->
<!--            </el-row>-->

            <el-row>
              <el-col :span="24">
                <el-form-item label="" label-width="0%" style="text-align: right">
                  <el-button type="primary" @click="uploadAttach">{{$t('cost.invoice001')}}</el-button><!-- AI识别发票 -->
                  <el-button type="primary" @click="createInvoice">{{$t('cost.invoice002')}}</el-button><!-- 添加其他票据 -->
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <bsp-grid
          class="bsp-grid"
          ref="itemListTable"
          :demoLoading.sync="demoLoading"
          :tableColumns.sync="tableColumns"
          :tableDatas.sync="tableDatas"
          @tableRefresh="tableRefresh"
          @updateColumn="updateColumn"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          :pagerConfig="pagerConfig"
          :checkbox-config="{ checkMethod: checkboxMethod, highlight: true, range: true}"
        >
          <template v-slot:discernCusIdText="{row}">
            <el-link type="primary" @click="toEditPage(row, 'view')" style = "text-overflow: ellipsis;white-space: nowrap;display:block;overflow: hidden;" >{{ row.cusName }}</el-link>
            <!--        <span>{{ discernCusMap[row.cusId]}}</span>-->
          </template>
          <template v-slot:discernStatusText="{row}">
            <span>{{ dicts.codeMap[row.status]}}</span>
          </template>
          <template v-slot:discernTdStatusText="{row}">
            <span>{{ row.isPause == "00901" ? "挂起" : dicts.codeMap[row.tdStatus]}}{{ (row.tdStatus == '80440003' || row.tdStatus == '80440007') ? '(' + row.tdRn + ')' : '' }}</span>
          </template>

          <template v-slot:operation="{row}">

          </template>
        </bsp-grid>

        <upload-attach ref="uploadAttach" :optParam="optParam" @reload="doUploadSubmit"></upload-attach>

        <confirm-invoice ref="confirmInvoice" class="confirmInvoice" @reload="doConfirmSubmit"></confirm-invoice>

        <invoice-edit ref="invoiceEdit" class="invoiceEdit" @reload="doEditSubmit"></invoice-edit>
      </div>
    </template>
    <div class="dialog-footer" slot="footer">
      <el-button @click="closeDialog">{{$t('cost.cost058')}}</el-button><!-- 取  消 -->
      <el-button type="primary" @click="submit">{{$t('cost.cost103')}}</el-button><!-- 添加至报销单 -->
    </div>
  </bsp-dialog>
</template>

<script>

import { getUserCusList, getUserCusListZz, getAllCusList} from "@/api/sys/cus";
import { getCloudCostDetailMobileList } from "@/api/cost/cost";
import UploadAttach from "@/views/cost/components/UploadAttach";
import bspGrid from "@/components/bsp/bsp-grid/grid";
import BspDialog from "@/components/bsp/bsp-dialog/bsp-dialog";
import BspDictsSelect from '@/components/bsp/bsp-dicts-select/bsp-dicts-select'
import { downloadFile } from '@/util/util'
import {mapGetters} from 'vuex';
import {formatDateSubstr10, formatDateSimple} from "@/util/date_format.js"
import InvoiceEdit from "@/views/cost/costInvoiceFolder/invoiceFolderEdit";
import ConfirmInvoice from "@/views/cost/costInvoiceFolder/confirmInvoiceList";

export default {
  name: "pickInvoice",
  components: { bspGrid , UploadAttach, BspDialog, InvoiceEdit, ConfirmInvoice },
  props:{
    optParams: {
      type: Object,
      default: function (){
        return {
        };
      },
    },
  },
  data() {
    return {
      searchForm:{},
      searchParams: {},
      tableDatas: [],
      tableColumns: [],
      filtersData: { page: 1, limit: 20 },
      pagerConfig: {
        total: 0,
        page: 1,
        limit: 20
      },
      demoLoading: true,
      loadingImport: false,
      loadingBtn: false,
      multipleSelection: [],
      visible: false,
    };
  },
  created() {
    if(this.optParams.type == "cost"){
      console.log("costInvoiceList==cost")
    }else{
      let that = this;
      this.demoLoading = true;
      this.getColumn();
      // this.init();
    }


  },
  mounted(){
    // console.log("批次号m",this.billBatch)
  },
  methods: {

    // 导出
    exportExcel() {

      this.demoLoading = true;

      var tdStatusArr = this.searchForm.tdStatusArr;
      var tdStatus = "";
      if(tdStatusArr != null && tdStatusArr.length > 0){
        for(var i = 0; i < tdStatusArr.length; i++){
          tdStatus += tdStatusArr[i] + ",";
        }
      }

      let params = {
        ...this.filtersData,
        searchParams : {
          tdStatus : tdStatus,
          cusId : this.searchForm.cusId,
          appliId : this.searchForm.appliId,
          handlerId : this.searchForm.handlerId,
          startEndDate : this.searchForm.startDate,
          endEndDate : this.searchForm.endDate,
          userTdRole : this.userTdRole,
          startCompleteDate: this.searchForm.startCompleteDate,
          endCompleteDate: this.searchForm.endCompleteDate,
          felId : this.searchForm.felId,
          tdType: this.searchForm.tdType,
          accountMonth: this.searchForm.accountMonth
        }
      }
      // exportTaskList(params)
      //   .then((res) => {
      //     if (res.headers['content-disposition'] === undefined) {
      //       this.demoLoading = false
      //       this.$message.error('账单下载失败,请联系运维人员！')
      //     } else {
      //       downloadFile(res)
      //       this.demoLoading = false
      //       this.$message.success("下载成功！");
      //     }
      //   })
    },
    // 查询
    handleSearch() {
      this.pagerConfig.page = 1;
      this.filtersData.page = 1;
      this.searchParams = this.searchForm;
      this.getData();
    },
    handleReset() {
      this.searchForm = {};
      this.initSelectForm();
      this.pagerConfig.page = 1;
      this.filtersData.page = 1;
      this.searchParams = this.searchForm;
      this.getData();
    },

    // 获取表头
    getColumn() {
      let column = [
        {
          type: "checkbox",
          fixed: 'left',
          minWidth: 50,
        },{
          field: "invoiceHm",
          title: this.$t("cost.invoice004"), //票据号码
          minWidth: '120px'
        },{
          field: "invoiceTypeTxt",
          title: this.$t("cost.invoice004"), //票据类型
          minWidth: '120px'
        },{
          field: "startDate",
          title: this.$t("cost.invoice006"), //票据日期
          minWidth: '120px'
        },{
          field: "includeTax",
          title: this.$t("cost.invoice007"), //票据金额
          minWidth: '120px'
        },{
          field: "createTime",
          title: this.$t("cost.invoice104"), //录入时间
          minWidth: '140px'
        },{
          field: "msg",
          title: this.$t("cost.invoice009"), //说明
          minWidth: '200px'
        },{
          field: "status",
          title: this.$t("cost.invoice010"), //发票状态
          minWidth: '120px',
          params:{slot:'discernStatusText'}
        }
        // ,{
        //   title: this.$t("cost.invoice013"), //操作
        //   minWidth : '160px',
        //   params:{slot:'operation'},
        //   fixed: 'right'
        // }
      ];
      this.$set(this,"tableColumns",column);
    },
    init() {
      // if(this.$route.query.from){
      //   alert(this.$route.query.tdStatus);
      // }
      // var user = this.$store.state.user.userInfo;
      // this.userId = user.userId;
      console.log("pickInvoice=" + this.optParams.type)
      this.getData();

    },
    submit(){
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        return this.$message.error(this.$t('homepage.txt027')) //至少选择一条数据
      }

      var that = this;
      this.$confirm(
        this.$t('cost.cost105'), // 是否确认将所选票据添加至报销单
        this.$t("homepage.txt017"), //提示
        {
          type: 'warning'
        }
      ).then(function(){
        //确认操作
        console.log("1111122")
        let ids =that.multipleSelection.map(item=> item.id)
        console.log("pickInvoice submit:" + ids);
        that.$emit('reload', that.multipleSelection);
        that.clearForm();
        that.visible = false;
      }).then((data) => {
        //取消操作
      }).catch(function (err) {
        //捕获异常
      });
    },
    uploadAttach(){
      let params = {
        batchId: null,
        btnType: "",
        type: "invoiceFolderOcr",
      }
      this.$refs.uploadAttach.visible = true;
      this.$refs.uploadAttach.params = params;
      this.$refs.uploadAttach.init();
    },
    createInvoice(){
      let params = {
        id: null,
        from: "invoiceList",
        opt:"add"
      }
      this.$refs.invoiceEdit.visible = true;
      this.$refs.invoiceEdit.params = params;
      this.$refs.invoiceEdit.init();
    },
    closeDialog () {
      this.visible = false;
      this.clearForm();
      // const that = this;
      // this.$confirm(
      //   '是否放弃当前操作！',
      //   '提示',
      //   {
      //     type: 'warning'
      //   }
      // ).then(function(){
      //   //确认操作
      //   that.clearForm();
      //   that.visible = false;
      // }).then((data) => {
      //   //取消操作
      // }).catch(function (err) {
      //   //捕获异常
      // });

    },
    close (){
      this.clearForm();
      this.visible = false;
    },
    clearForm(){
      this.multipleSelection = [];
    },

    //============================================================
    // 获取数据
    getData() {
      this.demoLoading = true;

      var status = "80510007";

      let params = {
        ...this.filtersData,
        searchParams : {
          endDate: this.searchForm.endDate,
          startDate: this.searchForm.startDate,
          timeType: "80130001",
          useType: "0",
          statusType: "usable",
          status: status,
          notInIds: this.optParams.notInIds,
        }
      }

      getCloudCostDetailMobileList(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.tableDatas = result.data.records;
            this.pagerConfig.total = result.data.total;

          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    //获取请求筛选数据/分页
    tableRefresh(filter, cal) {
      this.filtersData = filter;
      this.pagerConfig.page = filter.page;
      this.pagerConfig.limit = filter.limit;
      this.getData(cal);
    },
    updateColumn(columns) {
      //console.log(columns);
    },
    selectAllEvent({ checked, records, selection }) {
      this.multipleSelection = records;
    },
    selectChangeEvent({ checked, records }) {
      this.multipleSelection = records;
    },
    // 禁用表格复选框
    checkboxMethod({row}) {
      return true;
      //return row.discernStatus == '80130003';
    },

    doUploadSubmit(val) {
      console.log("doUploadSubmit", val);
      let params = {
        ids: null,
        from: "invoiceList",
        fileList: val
      }
      this.$refs.confirmInvoice.visible = true;
      this.$refs.confirmInvoice.optParams = params;
      this.$refs.confirmInvoice.init();
    },
    doConfirmSubmit(){
      this.init()
    },
    doEditSubmit() {
      this.init();
    },
    isNotBlank(str){
      if(str == null || str ==undefined || str == ''){
        return false;
      }else{
        return true;
      }
    }
  },
  destroyed(){
  },
  computed: {
    ...mapGetters(['billBatch','userInfo','dicts']),
  }
};
</script>

<style lang="scss">
</style>
